import { Label as Component } from './styled';

export const Label = Component;
